<div
  ngbDropdown
  class="d-block w-100 dropdown-container"
  container="body"
  #dropdown="ngbDropdown"
>
  <button
    type="button"
    class="btn btn-{{
      size()
    }} dropdown-toggle form-control text-truncate w-100 pe-4 text-start"
    ngbDropdownToggle
    #dropdownToggle
    [disabled]="disabled()"
    [ngClass]="{
      'control-status-danger':
        status() === 'danger' && !disabled() && selectedOption()?.value(),
      'control-status-success':
        status() === 'success' && !disabled() && selectedOption()?.value(),
    }"
    (click)="onToggle()"
  >
    {{ selectedOption()?.label() ?? placeholder() | translate }}
    @if (isOpen()) {
      <i class="fa fa-chevron-up fa-xs ps-2"></i>
    } @else {
      <i class="fa fa-chevron-down fa-xs ps-2"></i>
    }
  </button>
  <div
    ngbDropdownMenu
    class="dropdown-menu border"
    [style.min-width.px]="buttonWidth()"
  >
    @if (header()) {
      <div class="dropdown-header">
        <input
          type="text"
          class="form-control"
          [placeholder]="'shared.select.searchPlaceholder' | translate"
          [value]="searchValue()"
          (keyup)="search($event.target.value)"
        />
      </div>
      <div class="dropdown-divider"></div>
    }
    <div class="options-wrapper text-nowrap">
      <ng-content select="app-select-option"></ng-content>
    </div>
  </div>
</div>
